<!-- display-mobile-04 preview — publisher site, single in-page card -->
<app-mobile-frame>
  <!-- START: Site header -->
  <div class="gs-site-header d-flex flex-row align-items-center justify-content-between" frameTop>
    <i class="bi bi-list"></i>
    <span class="gs-skel gs-skel-brand"></span>
    <i class="bi bi-search"></i>
  </div>
  <!-- END: Site header -->

  <div class="gs-page">
    <span *ngFor="let w of linesAbove" class="gs-skel gs-skel-line" [style.width.%]="w" aria-hidden="true"></span>

    <!-- START: Real ad -->
    <a class="gs-promo d-block" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
      <span class="gs-card-image d-flex justify-content-center">
        <img [src]="hotel.image" alt="" />
        <i class="bi bi-info-circle gs-info"></i>
      </span>
      <span class="gs-card-body d-block">
        <span class="gs-card-title">{{ hotel.title }}</span>
        <span class="d-flex flex-row align-items-end justify-content-between">
          <span class="gs-card-meta">
            <span class="gs-card-description">{{ hotel.subtitle }}</span>
            <span class="gs-brand-name">Valamar</span>
          </span>
          <span class="gs-card-cta d-flex flex-row align-items-center">
            {{ ctaText }}<i class="bi bi-chevron-right"></i>
          </span>
        </span>
      </span>
    </a>
    <!-- END: Real ad -->

    <span *ngFor="let w of linesBelow" class="gs-skel gs-skel-line" [style.width.%]="w" aria-hidden="true"></span>
  </div>
</app-mobile-frame>
